import React, { ReactElement } from 'react';
import { Typography } from 'antd';
import { VizState } from '@cubejs-client/react';
import { getPriorityScaleColors } from '../../utils';
import { Chart } from '@threatadvisor/react-components';

export type DetectionCaseByClosureReasonProps = {
  clientUid: string;
  reportStart: string;
  reportEnd: string;
};

export default function DetectionCaseByClosureReason(props): ReactElement {
  const { clientUid, reportStart, reportEnd } = props;

  const getDetectionCountByClosureReason = (): VizState => {
    return {
      chartType: 'bar',
      pivotConfig: {
        x: ['detection_case.statusReason'],
        y: ['detection_case.priority', 'measures'],
        fillMissingDates: true
      },
      query: {
        measures: ['detection_case.count'],
        order: [
          ['detection_case.statusReason', 'asc'],
          ['detection_case.priority', 'asc']
        ],
        dimensions: ['detection_case.priority', 'detection_case.statusReason'],
        timeDimensions: [
          {
            dimension: 'detection_case.closedDate',
            dateRange: [reportStart, reportEnd]
          }
        ],
        filters: [
          {
            member: 'detection_case.status',
            operator: 'equals',
            values: ['Closed']
          },
          {
            member: 'detection_case.clientUid',
            operator: 'equals',
            values: [clientUid]
          },
          {
            member: 'detection_case.priority',
            operator: 'notEquals',
            values: ['P5', '5']
          }
        ]
      }
    };
  };

  return (
    <>
      <h2 className="text-uppercase">Detection Case By Closure Reason</h2>

      <figure>
        {' '}
        <Chart
          chartConfig={{
            colorField: 'series',
            isStack: true,
            stack: {
              groupBy: ['x', 'series'],
              series: true,
              y1: 'y1',
              y: 'y',
              reverse: true
            },
            ...getPriorityScaleColors()
          }}
          config={getDetectionCountByClosureReason()}
          showZerosStacked={['P1', 'P2', 'P3', 'P4']}
        />
        <figcaption>
          <Typography.Text type="secondary">
            Shows case closure reasons. Please see Appendix A for definitions.
          </Typography.Text>
        </figcaption>
      </figure>
    </>
  );
}
